import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Icon } from 'semantic-ui-react'
import media from '../../assets/styles/media'

export const Button = styled.button`
  border-radius: 23.3px;
  border: solid 2.2px #24ab17;
  color: ${({ fill }) => (fill ? '#fff' : '#24ab17')};
  background-color: ${({ fill }) => (fill ? '#24ab17' : '#fff')};
  font-family: 'proximanova-extrabold';
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.58px;
  text-align: center;
  min-width: 207px;
  min-height: 47px;
  cursor: pointer;
`

export const ModalBackground = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.333);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PagePadding = styled.div`
  padding: 34px 54px;

  @media print {
    padding: 0;
  }
`

export const PageTitle = styled.h1`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.34px;
  color: #656668;
  text-transform: uppercase;
`

const GoBackLink = styled(Link)`
  @media print {
    display: none;
  }
`

export const GoBack = ({ to, children }) => (
  <GoBackLink to={to}>
    <Icon name="arrow left" />
    {children}
  </GoBackLink>
)

const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 175px;
  border: solid 1.5px #bfbfbf;
  margin-bottom: 2rem;
`

const BlockContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
`
const BlockTitle = styled.h3`
  width: 100%;
  padding: 17px 30px;
  background: #f2f4f5;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.71;
  letter-spacing: 0.49px;
  color: #202020;
`
export const Block = ({ id, title, children }) => {
  return (
    <BlockContainer id={id}>
      <BlockTitle>{title}</BlockTitle>
      <BlockContent>{children}</BlockContent>
    </BlockContainer>
  )
}

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 25%;
  ${media.md`
    min-width: 20%;
  `}
`

export const Group = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  ${({ spaceBetween }) =>
    spaceBetween &&
    `
      justify-content: space-between;
    `}
  ${media.md`
    flex-direction: row;
    margin-bottom: 0;
  `}

  @media print {
    justify-content: space-between;
  }
`
